module.exports = __webpack_public_path__ + "static/img/promotionbg.78846a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion/promotionbg.png
// module id = eGVW
// module chunks = 1